import { useAppSelector } from '@/redux/store';

const useCheckVIPstatus = (): boolean | undefined => {
  return useAppSelector((state) => state.user.user?.VIP);
};

export { useCheckVIPstatus };
